export default function SFQrScannerIcon({}) {
  return (
    // <SvgIcon {...props}>
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30Z"
        fill="#A19BFD"
      />
      <path
        d="M56 30C56 44.3594 44.3594 56 30 56C15.6406 56 4 44.3594 4 30C4 15.6406 15.6406 4 30 4C44.3594 4 56 15.6406 56 30Z"
        fill="#A19BFD"
      />
      <path
        d="M40.9999 34.5713C40.9999 34.019 40.5522 33.5713 39.9999 33.5713C39.4476 33.5713 38.9999 34.019 38.9999 34.5713H40.9999ZM34.5713 38.9999C34.019 38.9999 33.5713 39.4476 33.5713 39.9999C33.5713 40.5522 34.019 40.9999 34.5713 40.9999L34.5713 38.9999ZM38.9999 34.5713C38.9999 37.0172 37.0172 38.9999 34.5713 38.9999L34.5713 40.9999C38.1217 40.9999 40.9999 38.1217 40.9999 34.5713H38.9999Z"
        fill="white"
      />
      <path
        d="M25.4286 40.9999C25.9809 40.9999 26.4286 40.5522 26.4286 39.9999C26.4286 39.4476 25.9809 38.9999 25.4286 38.9999V40.9999ZM21 34.5713C21 34.019 20.5523 33.5713 20 33.5713C19.4477 33.5713 19 34.019 19 34.5713H21ZM25.4286 38.9999C22.9828 38.9999 21 37.0172 21 34.5713H19C19 38.1217 21.8782 40.9999 25.4286 40.9999V38.9999Z"
        fill="white"
      />
      <path
        d="M24.5088 29.7879L25.4742 29.3588C28.3554 28.0783 31.6442 28.0783 34.5254 29.3588L35.4909 29.7879"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M34.5713 19C34.019 19 33.5713 19.4477 33.5713 20C33.5713 20.5523 34.019 21 34.5713 21V19ZM38.9999 25.4286C38.9999 25.9809 39.4476 26.4286 39.9999 26.4286C40.5522 26.4286 40.9999 25.9809 40.9999 25.4286H38.9999ZM34.5713 21C37.0172 21 38.9999 22.9828 38.9999 25.4286H40.9999C40.9999 21.8782 38.1217 19 34.5713 19V21Z"
        fill="white"
      />
      <path
        d="M19 25.4286C19 25.9809 19.4477 26.4286 20 26.4286C20.5523 26.4286 21 25.9809 21 25.4286H19ZM25.4286 21C25.9809 21 26.4286 20.5523 26.4286 20C26.4286 19.4477 25.9809 19 25.4286 19V21ZM21 25.4286C21 22.9828 22.9828 21 25.4286 21V19C21.8782 19 19 21.8782 19 25.4286H21Z"
        fill="white"
      />
    </svg>

    // </SvgIcon>
  );
}
